import React, { useState } from "react";

import "./closeoptions.scss";

const CloseOptions = (props:any) => {
  const eventOptions = [
    {
      text: "Close",
      id: 1,
    },
    {
      text: "Restart",
      id: 2,
    }
   
  ];

const [activeIndex, setActiveIndex] = useState(null);
const [isDisabled, setIsDisabled] = useState(false);
const [ clicked, setIsClicked] = useState(false);
 const [intitialClassName, setClassName] = useState("option-button");
  const [selectedOption, setSelectedOption] = useState("");

  const buttonsMarkup = eventOptions.map((option:any,index:any) => (
    <React.Fragment key={option.id}>
      <button 
        onClick={()=>{
          // Prevent multiple clicks after a selection has been made
          if (isDisabled && activeIndex !== index) {
            return;
          }
          setIsClicked(true);
          setIsDisabled(!isDisabled);
          setActiveIndex(index);
          setSelectedOption(option.text);
          setClassName("option-inactive");

          switch(option.id){
              case 1:props.actionProvider.handleCloseBot();  break;
              case 2:props.actionProvider.handleOptions(); break;
          }
        }} 
        className={activeIndex === index?"change-buttons":intitialClassName}  
        aria-pressed={activeIndex === index}
        tabIndex={0} // Ensure all buttons remain in tab order
      >
        {option.text}
      </button>
    </React.Fragment>
  ));

  return (
    <div className="options-container" role="group" aria-label="Close options">
      {buttonsMarkup}
      {selectedOption && (
        <div aria-live="polite" className="sr-only">
          Selected: {selectedOption}
        </div>
      )}
    </div>
  );
};

export default CloseOptions;
